/* eslint-disable max-classes-per-file */
import { Action } from '@ngrx/store';
import { ValidateIdentity } from './validate.model';
import { TwoFACode } from '@app/auth/core/state/auth.model';

export enum ActionTypes {
  VALIDATE = '[Auth] Validate',
  VALIDATE_SUCCESS = '[Auth] Validate Success',
  VALIDATE_FAILURE = '[Auth] Validate Failure',

  VALIDATE_LINK = '[Auth] Validate Link',
  VALIDATE_LINK_SUCCESS = '[Auth] Validate Link Success',
  VALIDATE_LINK_FAILURE = '[Auth] Validate Link Failure',

  VERIFY_2FA_CODE = '[Auth] Verify 2FA Code',
  VERIFY_2FA_CODE_FAILURE = '[Auth] Verify 2FA Code Failure',
}

export class Validate implements Action {
  public readonly type = ActionTypes.VALIDATE;

  constructor(public payload: ValidateIdentity) {}
}

export class ValidateSuccess implements Action {
  public readonly type = ActionTypes.VALIDATE_SUCCESS;
}

export class ValidateFailure implements Action {
  public readonly type = ActionTypes.VALIDATE_FAILURE;

  constructor(public payload: { code?: string; message: string; httpStatus?: number }) {}
}

export class ValidateEmailVerify2FACode implements Action {
  public readonly type = ActionTypes.VERIFY_2FA_CODE;

  constructor(public payload: TwoFACode) {}
}

export class ValidateEmailVerify2FACodeFailure implements Action {
  public readonly type = ActionTypes.VERIFY_2FA_CODE_FAILURE;

  constructor(public payload: { code: string }) {}
}

export class ValidateLink implements Action {
  public readonly type = ActionTypes.VALIDATE_LINK;

  constructor(public payload: Pick<ValidateIdentity, 'identityValidationToken' | 'email'>) {}
}

export class ValidateLinkSuccess implements Action {
  public readonly type = ActionTypes.VALIDATE_LINK_SUCCESS;
}

export class ValidateLinkFailure implements Action {
  public readonly type = ActionTypes.VALIDATE_LINK_FAILURE;

  constructor(public payload: { code?: string; message: string; httpStatus?: number }) {}
}

export type Actions =
  | ValidateLink
  | ValidateLinkFailure
  | ValidateLinkSuccess
  | Validate
  | ValidateSuccess
  | ValidateFailure
  | ValidateEmailVerify2FACode
  | ValidateEmailVerify2FACodeFailure;
